var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderItem1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 157,
    viewBox: "0 0 157 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.325 3.08983L155.032 1.7966L153.739 0.503174L104.428 1.80081L52.4614 1.80081L3.16156 0.503442L1.86315 1.80185L0.564731 3.10027L1.8621 52.4001L1.8621 104.367L0.564453 153.677L1.8577 154.971L3.15096 156.264L52.4614 154.966H104.428L153.713 156.263L155.019 154.957L156.325 153.652L155.028 104.367V52.4001L156.325 3.08983ZM25.2519 23.3632L24.3383 24.2769L23.4245 25.1906L24.3413 60.0269V96.74L23.4247 131.569L24.342 132.486L25.2593 133.404L60.0882 132.487H96.8013L131.638 133.404L132.551 132.49L133.465 131.576L132.548 96.74V60.0269L133.465 25.2087L132.542 24.2861L131.62 23.3636L96.8013 24.2799H60.0882L25.2519 23.3632Z",
    fill: "url(#paint0_linear_57_1373)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_1373",
    x1: 156.325,
    y1: 78.3835,
    x2: 0.564394,
    y2: 78.3835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE008F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C20505"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderItem1);
export default __webpack_public_path__ + "static/media/header-item-1.d71c77566fb730d46cfbddee1668b05b.svg";
export { ForwardRef as ReactComponent };